module.exports = __webpack_public_path__ + "img/vol04_character_text02.f223ecab.png";